import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponseModel } from 'src/app/core/services/api/api-response.model';
import { DataService } from 'src/app/core/services/api/data.service';
import { environment } from 'src/environments/environment';
import { FACILITY_ID_URL } from 'src/app/shared/config/app.constant';

@Injectable({
  providedIn: 'root',
})
export class DeviceManagmentService {
  constructor(
    private dataService: DataService<any>
  ) { }

  getServiceProviderList(): Observable<ApiResponseModel<any[]>> {
    const url = `${environment.apiUrl.casparDevice}${FACILITY_ID_URL}/serviceProviderList`;
    return this.dataService.getData(url);
  }

  getDeviceList(serviceProvider: string): Observable<ApiResponseModel<any[]>> {
    const url = `${environment.apiUrl.casparDevice}${FACILITY_ID_URL}/deviceList/${serviceProvider}`;
    return this.dataService.getData(url);
  }

  getDeviceDetails(serviceProvider: string, macId: string): Observable<ApiResponseModel<any[]>> {
    const url = `${environment.apiUrl.casparDevice}${FACILITY_ID_URL}/getdeviceDetail/${serviceProvider}/${macId}`;
    return this.dataService.getData(url);
  }

  getDeviceTypes(serviceProvider: string): Observable<ApiResponseModel<any[]>> {
    const url = `${environment.apiUrl.casparDevice}${serviceProvider}/modelList/`;
    return this.dataService.getData(url);
  }

  getBedList(serviceProvider: string): Observable<ApiResponseModel<any[]>> {
    const url = `${environment.apiUrl.casparDevice}${FACILITY_ID_URL}/getBedsWithServiceDevice/${serviceProvider}`;
    return this.dataService.getData(url);
  }

  getBedRoomSlotList(roomId: string, serviceProvider: string): Observable<ApiResponseModel<any[]>> {
    const url = `${environment.apiUrl.casparDevice}${roomId}/getRoomSlotsWithProviderDevice/${serviceProvider}`;
    return this.dataService.getData(url);
  }

  createDevice(payload: any): Observable<ApiResponseModel<any[]>> {
    const url = `${environment.apiUrl.casparDevice}${FACILITY_ID_URL}/manage/${payload.providerId}`;
    return this.dataService.post(url, payload);
  }

  updateDevice(payload: any): Observable<ApiResponseModel<any[]>> {
    const url = `${environment.apiUrl.casparDevice}${FACILITY_ID_URL}/manage/${payload.providerId}`;
    return this.dataService.put(url, payload);
  }

  deleteDevice(macId: any, serviceProvider: string): Observable<ApiResponseModel<any[]>> {
    const url = `${environment.apiUrl.casparDevice}${FACILITY_ID_URL}/delete/${macId}/${serviceProvider}`;
    return this.dataService.delete(url, {});
  }
}
